import React from 'react';

const Card = ({ children, className = '', onClick }) => (
  <div 
    onClick={onClick}
    className={`bg-white rounded-xl shadow-[0_2px_8px_rgba(0,0,0,0.04)] border border-[#EDF2F7] overflow-hidden ${className}`}
  >
    {children}
  </div>
);

export default Card;
